import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withKeys as _withKeys, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section page is-flex is-fullheight is-flex-direction-row is-align-items-center is-justify-content-center" }
const _hoisted_2 = { class: "box login-box" }
const _hoisted_3 = { class: "logo-wrapper mt-4 mb-3" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "center mb-3" }
const _hoisted_6 = { class: "is-size-5 roboto" }
const _hoisted_7 = {
  key: 2,
  class: "loading center w-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", { src: _ctx.logo }, null, 8 /* PROPS */, _hoisted_4)
      ]),
      (_ctx.failed)
        ? (_openBlock(), _createBlock(_component_n_alert, {
            key: 0,
            class: "w-100 mb-3",
            title: _ctx.$t('login.error'),
            type: "error"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('login.login_invalid')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('login.please_connect')), 1 /* TEXT */)
      ]),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_n_form, {
            key: 1,
            ref: "form",
            class: "w-100",
            model: _ctx.result,
            "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.result) = $event)),
            rules: _ctx.rules,
            path: "username",
            onKeydown: _withKeys(_ctx.onSubmit, ["enter"]),
            "show-label": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_form_item, {
                label: _ctx.$t('login.form.username_field'),
                path: "username"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_input, {
                    value: _ctx.result.username,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.result.username) = $event)),
                    clearable: "",
                    placeholder: _ctx.$t('login.form.username_field')
                  }, null, 8 /* PROPS */, ["value", "placeholder"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["label"]),
              _createVNode(_component_n_form_item, {
                label: _ctx.$t('login.form.password_field'),
                path: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_input, {
                    value: _ctx.result.password,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.result.password) = $event)),
                    type: "password",
                    "show-password-on": "mousedown",
                    clearable: "",
                    placeholder: _ctx.$t('login.form.password_field')
                  }, null, 8 /* PROPS */, ["value", "placeholder"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["label"]),
              _createVNode(_component_n_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_n_button, {
                    class: "w-100",
                    type: "success",
                    onClick: _ctx.onSubmit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('login.connect')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["model", "rules", "onKeydown"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_n_spin, { size: "large" })
          ])),
      _createVNode(_component_router_link, {
        class: "has-text-success mb-5",
        to: "/reset-password"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('login.forgotten_password')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_router_link, {
        class: "w-100",
        to: { name: 'register' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            size: "large",
            class: "w-100",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('login.create_account')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}